import { Vector3 } from "three";

const SPEED = 0.05;

export type KeyControls = Record<string, boolean>;

export const moveOrbitControl = (controls: KeyControls, cameraPosition: Vector3, target: Vector3) => {
    if (Object.values(controls).find((item) => item)) {
        const targetProjected = target.clone();
        targetProjected.y = cameraPosition.y;

        const dir = cameraPosition.clone().sub(target).normalize();
        const dirProjected = cameraPosition.clone().sub(targetProjected).normalize();
        const ortho = new Vector3();
        ortho.crossVectors(dirProjected.clone(), dir.clone());
        ortho.normalize();

        if (controls["KeyW"] || controls["ArrowUp"]) {
            const offset = dirProjected.clone().negate().multiplyScalar(SPEED);
            cameraPosition.add(offset);
            target.add(offset);
        }
        if (controls["KeyS"] || controls["ArrowDown"]) {
            const offset = dirProjected.clone().multiplyScalar(SPEED);
            cameraPosition.add(offset);
            target.add(offset);
        }
        if (controls["KeyA"] || controls["ArrowLeft"]) {
            const offset = ortho.clone().multiplyScalar(SPEED);
            cameraPosition.add(offset);
            target.add(offset);
        }
        if (controls["KeyD"] || controls["ArrowRight"]) {
            const offset = ortho.clone().negate().multiplyScalar(SPEED);
            cameraPosition.add(offset);
            target.add(offset);
        }
    }
};
